export const SyncSuggestionsInPublish = {
  flow: 'y',
  gap: 'A',
  margin: '- -Z2',
  childExtends: 'DomainItem',
  childProps: {
    Icon: {
      name: '{{ icon }}'
    },
    Hgroup: {
      H: {
        text: (el, s) => el.call('polyglot', s.title || '')
      },
      P: {
        text: (el, s) => el.call('polyglot', s.descr || '')
      }
    },
    Upgrade: null,
    Button: {
      extends: ['CanvasButton', 'Button'],
      padding: 'Y2 Z2',
      margin: '-Y -Z2 - auto',
      text: '{{ publish.sync.connect | polyglot }}',
      icon: 'plus oval',
      gap: 'Y1',
      Icon: {
        order: 2,
        color: 'blue'
      },
      fontSize: 'Z2'
    },
    align: 'start'
  },
  children: [
    {
      icon: 'globe',
      title: 'publish.sync.website.title',
      descr: 'publish.sync.website.descr'
    },
    {
      icon: 'figma',
      title: 'Figma',
      descr: 'publish.sync.figma.descr'
    },
    {
      icon: 'wordpress',
      title: 'Wordpress',
      descr: 'publish.sync.wordpress.descr'
    },
    {
      icon: 'github',
      title: 'Github',
      descr: 'publish.sync.github.descr'
    }
  ],
  childrenAs: 'state'
}
